import { useMemo } from 'react';
import { useAppSelector } from '../../application/store/useStore';
export var usePermissionGranted = function (_a) {
    var _b = _a.permissions, permissions = _b === void 0 ? [] : _b;
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    return useMemo(function () {
        if (!currentUser || !currentUser.permissions)
            return false;
        var userPermissions = currentUser.permissions;
        return permissions.every(function (permission) { return userPermissions.includes(permission); });
    }, [currentUser, permissions]);
};
